// client/src/components/marketer/MarketerPwChange.js
import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

function MarketerPwChange() {
  const [currentPw, setCurrentPw] = useState('');
  const [newPw, setNewPw] = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [loading, setLoading] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalMsg, setModalMsg] = useState('');
  const openModal = (msg) => { setModalMsg(msg); setModalOpen(true); };

  const isValidPw = (pw) => pw.length >= 8 && pw.length <= 20 && !/\s/.test(pw);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!currentPw.trim()) { openModal('현재 비밀번호를 입력해주세요.'); return; }
    if (!isValidPw(newPw)) { openModal('새 비밀번호는 8~20자이며 공백은 불가합니다.'); return; }
    if (newPw !== confirmPw) { openModal('변경 비밀번호 재확인이 일치하지 않습니다.'); return; }
    if (currentPw === newPw) { openModal('현재 비밀번호와 다른 비밀번호로 변경해주세요.'); return; }

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/marketer/mybiz/password-change`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ currentPassword: currentPw, newPassword: newPw })
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data?.ok) {
        setCurrentPw(''); setNewPw(''); setConfirmPw('');
        openModal('비밀번호가 변경되었습니다.');
      } else {
        openModal(data?.message || '비밀번호 변경에 실패했습니다.');
      }
    } catch {
      openModal('서버 요청 실패');
    }
    setLoading(false);
  };

  return (
    <div>
      <div className="mb-page-header">
        <h2 className="mb-page-title">비밀번호 변경</h2>
        <p className="mb-page-description">계정 보안을 위해 비밀번호를 주기적으로 변경해주세요.</p>
      </div>

      <div className="mb-grid-2" style={{ alignItems: 'stretch' }}>
        {/* 왼쪽: 보안 가이드 */}
        <div className="mb-card" style={{ margin: 0 }}>
          <h3 className="mb-section-title">비밀번호 보안 가이드</h3>
          <div className="checkline">
            <i>✓</i>
            <div>
              <b>8~20자 길이</b>
              <span>공백 없이 입력해주세요</span>
            </div>
          </div>
          <div className="checkline">
            <i>✓</i>
            <div>
              <b>주기적 변경 권장</b>
              <span>3개월마다 변경을 권장합니다</span>
            </div>
          </div>
          <div className="checkline">
            <i>✓</i>
            <div>
              <b>다른 사이트와 다르게</b>
              <span>다른 서비스와 동일한 비밀번호 사용을 피하세요</span>
            </div>
          </div>
          <div className="checkline">
            <i>✓</i>
            <div>
              <b>안전한 조합 사용</b>
              <span>영문, 숫자, 특수문자를 조합하면 더 안전합니다</span>
            </div>
          </div>
        </div>

        {/* 오른쪽: 비밀번호 변경 폼 */}
        <form
          onSubmit={handleSubmit}
          className="mb-card"
          style={{ margin: 0, height: '100%', display: 'flex', flexDirection: 'column' }}
        >
          <div className="mb-form-group">
            <label className="mb-form-label">현재 비밀번호</label>
            <input
              type="password"
              placeholder="현재 비밀번호를 입력하세요"
              value={currentPw}
              onChange={(e) => setCurrentPw(e.target.value)}
              disabled={loading}
              className="mb-form-control"
            />
          </div>

          <div className="mb-form-group">
            <label className="mb-form-label">변경할 비밀번호</label>
            <input
              type="password"
              placeholder="새 비밀번호를 입력하세요 (8~20자)"
              value={newPw}
              onChange={(e) => setNewPw(e.target.value)}
              disabled={loading}
              className="mb-form-control"
            />
            {newPw && !isValidPw(newPw) && (
              <div className="mb-info-hint" style={{ color: '#e5484d', marginTop: 6 }}>
                8~20자, 공백 불가
              </div>
            )}
          </div>

          <div className="mb-form-group">
            <label className="mb-form-label">비밀번호 재확인</label>
            <input
              type="password"
              placeholder="새 비밀번호를 한 번 더 입력하세요"
              value={confirmPw}
              onChange={(e) => setConfirmPw(e.target.value)}
              disabled={loading}
              className="mb-form-control"
            />
            {confirmPw && newPw !== confirmPw && (
              <div className="mb-info-hint" style={{ color: '#e5484d', marginTop: 6 }}>
                비밀번호가 일치하지 않습니다.
              </div>
            )}
          </div>

          <button
            type="submit"
            disabled={loading}
            className="mb-btn mb-btn-primary mb-btn-lg mb-btn-full"
            style={{ marginTop: 'auto' }}
          >
            {loading ? '변경 중...' : '비밀번호 변경하기'}
          </button>
        </form>
      </div>

      {modalOpen && (
        <div className="mbm-overlay">
          <div className="mb-card mbm" style={{ width: 360, margin: 0, textAlign: 'center', padding: '32px' }}>
            <p style={{ margin: 0, fontSize: 16, color: '#0b1324', lineHeight: 1.6 }}>{modalMsg}</p>
            <div className="mbm-foot">
              <button
                className="mb-btn mb-btn-primary"
                onClick={() => setModalOpen(false)}
              >
                확인
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MarketerPwChange;
